module.exports = __webpack_public_path__ + "static/img/4.c507f7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/4.png
// module id = 8QeW
// module chunks = 0